import { Button, Modal } from "antd";
import styled from "styled-components/macro";

import useBetaFeatures from "hooks/useBetaFeatures";

import { IconNoviMark, IconNoviWordmark } from "components/icons";

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
}

function AboutModal({ open, onClose }: AboutModalProps) {
  const { hasFeature } = useBetaFeatures();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={false}
      centered
      width={533}
      footer={
        <Button type="primary" onClick={onClose}>
          OK
        </Button>
      }
      // rc-dialog forwards data-* only to the zero-height `.ant-modal-root`;
      // `wrapProps` puts it on the visible wrapper.
      wrapProps={{ "data-testid": "about-modal" }}>
      <Lockup>
        <IconNoviMark size={64} />
        <IconNoviWordmark size={60} />
      </Lockup>
      <Line>
        Copyright © 2014 - {new Date().getFullYear()} Novi, All rights reserved.
      </Line>
      <Line>
        Novi Labs software is made possible by{" "}
        <a href="/third-party-licenses.txt" target="_blank" rel="noopener noreferrer">
          open source software
        </a>
      </Line>
      {hasFeature("Rig And Frac Layers") && (
        <Line>Rig and Frac Data powered by Kayrros.</Line>
      )}
    </Modal>
  );
}

export default AboutModal;

// Bottom-aligned: the wordmark's viewBox reserves headroom for the dot over
// the "i", so its letterforms sit on the mark's baseline as in the brand lockup.
const Lockup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: var(--space-2);
  margin-bottom: var(--space-5);
  color: var(--color-text);
`;

const Line = styled.p`
  margin: 0 0 var(--space-3);
  color: var(--color-text);
`;
